/**
 * Optional live kicker for AppChromeHeader (page-owned stats).
 * Pages set while mounted; chrome falls back to static appChromeMeta.
 */

let override = null;
const listeners = new Set();

export function getAppChromeKickerOverride() {
  return override;
}

export function setAppChromeKickerOverride(kicker) {
  const next = kicker == null || kicker === '' ? null : String(kicker);
  if (override === next) return;
  override = next;
  listeners.forEach((fn) => fn(override));
}

export function clearAppChromeKickerOverride() {
  setAppChromeKickerOverride(null);
}

export function subscribeAppChromeKickerOverride(listener) {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
